import { faAngleLeft as faAngleLeftLight } from "@fullscript/pro-light-svg-icons";
import { faLock, faAngleLeft } from "@fullscript/pro-regular-svg-icons";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Link, Stepper, Separator, Typography, Spacer } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { Container } from "@shared/layouts";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./JourneyCheckoutHeaderNav.styles";

interface Props {
  onBack?: () => void;
}

const JourneyCheckoutHeaderNav = ({ onBack }: Props) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const handleBackButtonPress = useCallback(() => onBack?.(), [onBack]);

  const renderBackButton = () => {
    if (tablet.lessThan) {
      const icon = faAngleLeft;

      return (
        <Link isColor="system" isUnderLined={false} onClick={handleBackButtonPress}>
          <FontAwesomeIcon size="lg" icon={icon} />
        </Link>
      );
    }

    return (
      <div css={styles.buttonWrapper}>
        <Link isColor="system" onClick={handleBackButtonPress}>
          <FontAwesomeIcon size="lg" icon={faAngleLeftLight} />
          <Spacer width="quarter" />
          {t(l.journeyCheckout.header.backButton)}
        </Link>
      </div>
    );
  };

  const stepperNavigation = () => {
    return (
      <div css={tablet.greaterThan ? styles.stepperWrapper : styles.mobileStepperWrapper}>
        <Stepper
          steps={[
            { label: t(l.journeyCheckout.header.patientInfo) },
            { label: t(l.journeyCheckout.header.billingInformation) },
            { label: t(l.journeyCheckout.header.payment) },
          ]}
          currentStep={1}
          isIncompleteFinalStep
          css={styles.stepperNav}
        />
      </div>
    );
  };

  return (
    <>
      <header css={styles.header}>
        <Container css={styles.wrapper}>
          {renderBackButton()}
          {!!tablet.greaterThan && stepperNavigation()}
          <Typography sizeOverride="body" type="h1" isSecondaryWeight css={styles.text}>
            <FontAwesomeIcon size="lg" icon={faLock} css={styles.icon} />
            {t(l.journeyCheckout.header.secureCheckout)}
          </Typography>
        </Container>
      </header>
      <Separator />
      {!tablet.greaterThan && stepperNavigation()}
    </>
  );
};

export { JourneyCheckoutHeaderNav };
